'use client';

import { useToast } from '@dolcevia/lib/hooks/useToast';
import { subscribeNewsletter } from '@dolcevia/lib/send-email';
import { useTranslations } from 'next-intl';
import { type ChangeEvent, useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';

export const NewsletterInput = () => {
  const { toast } = useToast();
  const t = useTranslations('Footer');
  const [emailSearch, updateEmailSearch] = useState('');
  const onChangeEmail = (e: ChangeEvent<HTMLInputElement>) => {
    updateEmailSearch(e.target.value);
  };
  const handleSubmit = async () => {
    const response = await subscribeNewsletter(emailSearch);
    if (response.error) {
      toast({
        variant: 'destructive',
        description: response.error,
      });
    } else {
      toast({
        description: 'Votre email a bien été enregistré',
      });
    }
  };
  return (
    <>
      <Input
        type="email"
        placeholder="Email"
        value={emailSearch}
        onChange={onChangeEmail}
        className="bg-white border-none h-12 w-full"
      />
      <Button
        type="submit"
        className="w-full md:w-auto"
        onClick={async () => await handleSubmit()}
      >
        {t("S'inscrire")}
      </Button>
    </>
  );
};
